// CleverTap/DataLayer constants for Indices insights (pre & post market insights)
// Values are aligned with `pre_and_post_market_insights CT DL.csv`.

export const INDICES_INSIGHTS_COMPONENT_NAME = "indices_insights_cards";

export const INDICES_INSIGHTS_CLICK_TYPE_CARDS = "indices_insights_cards_cards_click";

export const INDICES_INSIGHTS_CLICK_TYPE_BUTTON = "indices_insights_cards_button_click";

export const INDICES_INSIGHTS_PRODUCT_CATEGORY = "investment";

export const INDICES_INSIGHTS_PROPERTY_TYPE = "clp";

export const INDICES_INSIGHTS_PRODUCT_NAME = "pre and post market insights - trading mall";

export const INDICES_INSIGHTS_SECTION_ENTRYPOINT = "horizontal/entrypoint";

// Keep parity with existing trading-mall CT journey tag to avoid surprises.
export const INDICES_INSIGHTS_JOURNEY_TAG = "Demat";

// Sprint/campaign identifiers shown as examples in the CT DL template.
export const INDICES_INSIGHTS_CAMPAIGN = "DPAOP3| Mar";
export const INDICES_INSIGHTS_SPRINT = "DPAOP3| Mar";

export const INDICES_INSIGHTS_REFERENCE_ID = "indices_insights_cards";

